import React, { useEffect } from 'react'
import SlickSlider, {
  CustomArrowProps as ReactSlickCustomArrowProps,
  Settings as ReactSlickSettings
} from 'react-slick'

export interface CustomArrowProps extends ReactSlickCustomArrowProps {}

export interface Settings extends ReactSlickSettings {}

interface CarouselScrollLockProps extends Settings {
  sliderRef?: React.RefObject<SlickSlider>
}

const SliderWithScrollLock: React.FC<CarouselScrollLockProps> = ({
  children,
  sliderRef,
  ...rest
}) => {
  let firstClientX: number, clientX: number

  const preventTouch = (e: TouchEvent) => {
    const minValue = 5 // threshold

    clientX = e.touches[0].clientX - firstClientX

    // Vertical scrolling does not work when you start swiping horizontally.
    if (Math.abs(clientX) > minValue) {
      e.preventDefault()
      e.returnValue = false

      return false
    }
  }

  const touchStart = (e: TouchEvent) => {
    firstClientX = e.touches[0].clientX
  }

  let containerRef: React.RefObject<HTMLDivElement> = React.createRef()

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.addEventListener('touchstart', touchStart)
      containerRef.current.addEventListener('touchmove', preventTouch, {
        passive: false
      })
    }

    return () => {
      if (containerRef.current) {
        containerRef.current.removeEventListener('touchstart', touchStart)
        //@ts-ignore
        containerRef.current.removeEventListener('touchmove', preventTouch, {
          //@ts-ignore
          passive: false
        })
      }
    }
  })

  return (
    <div ref={containerRef}>
      <SlickSlider ref={sliderRef} {...rest}>
        {children}
      </SlickSlider>
    </div>
  )
}

export { SlickSlider }

export default SliderWithScrollLock
